module.exports = __webpack_public_path__ + "static/media/3.8e4bb71d.jpg";